module.exports = __webpack_public_path__ + "img/Tecnologia4.0.74800750.jpg";